import React from "react";
import { renderToString } from "react-dom/server";
import * as L from "leaflet";
import axios from "axios";

L.TileLayer.BetterWMSRaster = L.TileLayer.WMS.extend({
  initialize: function (url, options, featureResolution = 0.00001) {
    this.popup = undefined;
    this.featureResolution = featureResolution;
    L.TileLayer.WMS.prototype.initialize.call(this, url, options);
  },
  onAdd: function (map) {
    // Triggered when the layer is added to a map.
    //   Register a click listener, then do all the upstream WMS things
    L.TileLayer.WMS.prototype.onAdd.call(this, map);
    map.on("click", this.getFeatureInfo, this);
  },
  onRemove: function (map) {
    // Triggered when the layer is removed from a map.
    //   Unregister a click listener, then do all the upstream WMS things
    L.TileLayer.WMS.prototype.onRemove.call(this, map);
    map.off("click", this.getFeatureInfo, this);
  },
  mapPopup: function (data) {
    const key = Object.keys(data.features[0].properties)[0];
    const value = data.features[0].properties[key];
    if (parseFloat(value) < -5000) return undefined;
    return renderToString(
      <div className="row text-center px-2">
        <div
          className="col-12 mb-2 mt-1 text-center"
          style={{ fontWeight: "bolder" }}
        >
          {key.toUpperCase()}
        </div>
        <div className="col-12 mb-1">{value.toFixed(2)} m</div>
        <button
          type="button"
          className="btn btn-primary btn-lg btn-block"
          id="start_simulation_button"
          style={{
            height: "20px",
            fontSize: "14px",
            paddingBottom: "21px",
            paddingTop: "1px",
            marginLeft: "12px",
            marginRight: "12px",
            marginTop: "8px",
          }}
        >
          Start simulation
        </button>
      </div>
    );
  },
  getFeatureInfo: function (event) {
    if (this.popup !== undefined) {
      this.popup = undefined;
      return;
    }
    var url = this.getFeatureInfoUrl(event.latlng);
    var showResults = L.Util.bind(this.showGetFeatureInfo, this);
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        showResults(
          null,
          event.latlng,
          this.mapPopup(data),
          data.features[0].properties[
            Object.keys(data.features[0].properties)[0]
          ]
        );
      })
      .catch((error) => {
        showResults(error);
      });
  },
  getFeatureInfoUrl: function (latlng) {
    var params = {
      request: "GetFeatureInfo",
      service: "WMS",
      version: "2.0.0",
      CRS: "EPSG:4326",
      LAYERS: this.wmsParams.layers,
      QUERY_LAYERS: this.wmsParams.layers,
      info_format: "application/json",
      x: 0,
      y: 0,
      HEIGHT: 1,
      WIDTH: 1,
      BBOX: `${latlng.lng - this.featureResolution},${
        latlng.lat - this.featureResolution
      },${latlng.lng + this.featureResolution},${
        latlng.lat + this.featureResolution
      }`,
    };

    return this._url + L.Util.getParamString(params, this._url, true);
  },

  showGetFeatureInfo: function (err, latlng, content, pointDepth) {
    return;
    if (err || content === undefined) {
      // window.alert("Invalid coordinates");
      return;
    }
    // Otherwise show the content in a popup, or something.
    this.popup = L.popup({ maxWidth: 800 })
      .setLatLng(latlng)
      .setContent(content);
    this.popup.on("add", () => {
      document
        .getElementById("start_simulation_button")
        .addEventListener("click", () => {
          document
            .getElementById("start_simulation_button")
            .removeEventListener("click", () => {});

          this.getInfraCreazione(
            {
              type: "Point",
              coordinates: [latlng.lng, latlng.lat],
            },
            pointDepth,
            this.history
          );
        });
    });
    var found = false;
    this._map.eachLayer((layer) => {
      if ("editing" in layer) {
        found = true;
      }
    });
    if (found === false) this.popup.openOn(this._map);
  },
});

export default L.tileLayer.betterWmsRaster = function (url, options) {
  return new L.TileLayer.BetterWMSRaster(url, options);
};
